import React from "react";
import "./About.css";
import {
    SiExpress,
    SiNestjs,
    SiJsonwebtokens,
    SiVercel,
    SiMysql,
    SiMongodb,
    SiTailwindcss,
    SiJavascript,
    SiNodedotjs,
    SiFirebase,
    SiReact,
    SiTypescript,
    SiNextdotjs,
    SiPostgresql,
    SiJenkins,
    SiGithub,
} from "react-icons/si";
import { FaFileDownload } from "react-icons/fa";
import skills from "./data/skills.json";

const About = () => {
    const onButtonClick = () => {
        // using Java Script method to get PDF file
        fetch("/Resume.pdf").then((response) => {
            response.blob().then((blob) => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = "Gourob_Resume.pdf";
                alink.click();
            });
        });
    };

    return (
        <div id="about" className="my-20">
            <div>
                <h1 className="font-semibold opacity-30 text-yellow-100 text-4xl md:text-5xl text-center mt-2 mb-4">
                    ABOUT ME
                </h1>
            </div>
            <div
                className="rounded-lg p-5 my-10 flex flex-col lg:flex-row items-center gap-12"
                data-aos="fade-up"
                data-aos-easing="ease-out-cubic"
                data-aos-duration="1000"
            >
                <div className="w-full">
                    <div className="mb-8">
                        <h2 className="font-semibold opacity-50 text-yellow-100 text-xl md:text-2xl mb-4">
                            Technical Expertise
                        </h2>
                        <ul className="space-y-2">
                            {skills.map((skill, index) => (
                                <li key={index} className="flex items-center">
                                    <p>
                                        <span className="mr-2">⚙️</span>
                                        <strong className="text-yellow-100 opacity-50">
                                            {skill.category}:
                                        </strong>
                                        &nbsp;
                                        <span className="text-yellow-100">
                                            {skill.tools.join(", ")}
                                        </span>
                                    </p>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="mt-14">
                        <h2 className="font-semibold opacity-50 text-yellow-100 text-xl md:text-2xl mb-4">
                            Professional Course
                        </h2>
                        <ul className="space-y-2">
                            <li className="flex items-center">
                                <p>
                                    <span className="mr-2">⚙️</span>
                                    &nbsp;
                                    <span className="text-yellow-100">
                                        Complete web development course with
                                        Jhankar Mahbub by{" "}
                                        <strong>Programming Hero</strong>
                                    </span>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="w-full">
                    <div className="mb-8">
                        <h2 className="font-semibold opacity-50 text-yellow-100 text-xl md:text-2xl">
                            Professional Experience
                        </h2>
                        <div className="container max-w-5xl px-4 py-4 mx-auto">
                            <div className="relative col-span-12 px-4 space-y-6 sm:col-span-9">
                                <div className="col-span-12 space-y-12 relative px-4 sm:col-span-8 sm:space-y-8 sm:before:absolute sm:before:top-2 sm:before:bottom-0 sm:before:w-0.5 sm:before:-left-3 before:dark:bg-gray-300">
                                    <div className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-orange-500">
                                        <h3 className="text-xl text-orange-400 font-semibold tracking-wide">
                                            Akij Venture Ltd.{" "}
                                        </h3>
                                        <h4 className="text-lg text-yellow-100 font-semibold tracking-wide">
                                            Software Developer (Fulltime)
                                        </h4>
                                        <time className="text-xs tracking-wide uppercase dark:text-gray-600">
                                            Jun 2023 - Present
                                        </time>
                                        <p className="mt-3 text-yellow-100 opacity-90">
                                            Working on several major enterprise
                                            projects, primarily developing
                                            backend services using Node.js,
                                            NestJS, MySQL and MongoDB. And also
                                            deploying applications using CI/CD
                                            pipelines with Vercel and Jenkins.
                                        </p>
                                    </div>
                                    <div className="flex flex-col sm:relative sm:before:absolute sm:before:top-2 sm:before:w-4 sm:before:h-4 sm:before:rounded-full sm:before:left-[-35px] sm:before:z-[1] before:dark:bg-orange-500">
                                        <h3 className="text-xl text-orange-400 font-semibold tracking-wide">
                                            Akij Venture Ltd.{" "}
                                        </h3>
                                        <h4 className="text-lg text-yellow-100 font-semibold tracking-wide">
                                            Software Developer (Internship)
                                        </h4>
                                        <time className="text-xs tracking-wide uppercase dark:text-gray-600">
                                            Jan 2023 - May 2023
                                        </time>
                                        <p className="mt-3 text-yellow-100 opacity-90">
                                            Developed and maintained web
                                            applications using Next.js, Node.js,
                                            and MongoDB. Maintained and updated
                                            existing codebases, and collaborated
                                            with the team to design and
                                            implement new features based on user
                                            feedback.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-7 -mt-2">
                        <button
                            onClick={onButtonClick}
                            className="btn-brand-primary"
                        >
                            Resume <FaFileDownload className="ml-2" />
                        </button>

                        <a
                            href="#contact"
                            className="btn-brand-secondary"
                        >
                            Contact Me
                        </a>
                    </div>
                </div>
            </div>
            <div className="w-full">
                <h1 className="font-semibold opacity-50 text-yellow-100 text-xl md:text-2xl text-center mt-2 mb-8">
                    MY SKILLS
                </h1>
                <div className="grid grid-cols-3 lg:grid-cols-8 sm:grid-cols-4 justify-items-center gap-8">
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiNodedotjs />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>Node.js</span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart ">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiNestjs />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>NestJS</span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiMysql />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>Mysql</span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiJavascript />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>JavaScript</span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiNextdotjs />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>Next.js </span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiMongodb />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>MongoDB</span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiTypescript />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>Typescript</span>
                            </div>
                        </div>
                    </div>

                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiReact />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>React</span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiTailwindcss />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>TailwindCSS </span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiPostgresql />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>Postgresql</span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiGithub />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>GitHub</span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiFirebase />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>Firebase</span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiExpress />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>Express.js</span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiJsonwebtokens />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>JSON Web Token</span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiVercel />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>Vercel</span>
                            </div>
                        </div>
                    </div>
                    <div className="logo-cart">
                        <div className="logo-cart-inner">
                            <div className="logo-front logoShadow rounded-2xl flex justify-center items-center">
                                <span className="text-orange-400  text-4xl">
                                    <SiJenkins />
                                </span>
                            </div>
                            <div className="logo-back rounded-2xl logoShadow text-orange-400   text-sm flex justify-center items-center">
                                <span>Jenkins</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
